export default class Stopwatch {
  private startTime: number = 0
  private intervalId: number | null = null
  private onUpdate: (formattedTime: string) => void
  private onStop: () => void

  constructor(onUpdate: (formattedTime: string) => void, onStop: () => void) {
    this.onUpdate = onUpdate
    this.onStop = onStop
  }

  start(): void {
    this.startTime = Date.now()

    this.intervalId = setInterval(() => {
      const elapsed = Date.now() - this.startTime
      const seconds = Math.floor(elapsed / 1000)
      const minutes = Math.floor(seconds / 60)
      const remainingSeconds = seconds % 60

      const formatted = `${String(minutes).padStart(2, '0')}:${String(
        remainingSeconds
      ).padStart(2, '0')}`
      this.onUpdate(formatted)
    }, 1000)
  }

  stop(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId)
      this.intervalId = null
    }

    this.onStop()
  }
}
